import $ from 'jquery';
import 'slick-carousel';

$(document).ready(function () {

	const customPrev =
		"<button type='button' class='slick-prev pull-left'><svg class='svg-icon pagination-arrow'><use xlink:href='#pagination-left'></svg></button>";
	const customNext =
		"<button type='button' class='slick-next pull-right'><svg class='svg-icon pagination-arrow'><use xlink:href='#pagination-right'></svg></button>";

	$('.old .gallery-wrapper').slick();

	$('.flexible-content-page .gallery-wrapper').slick({
		prevArrow: customPrev,
		nextArrow: customNext,
        arrows: true,
	});

	// image on top - landing page v2
	$('.page-landing-v2 .images, .page-landing-v3 .images').slick({
		arrows: false,
		dots: true,
		customPaging: function (slider, i) {
			var thumb = $(slider.$slides[i]).data();
			return '<a>' + (i + 1) + '</a>';
		},
	});

	// product bottom - landing page v2
	$('.page-landing-v2 .gallery-wrapper-product').slick({
		arrows: false,
		dots: true,
		customPaging: function (slider, i) {
			var thumb = $(slider.$slides[i]).data();
			return '<a>' + (i + 1) + '</a>';
		},
	});

	// product bottom - landing page v3
	$('.page-landing-v3 .gallery-wrapper-product').slick({
		arrows: true,
		dots: false,
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		mobileFirst: true,
		prevArrow: customPrev,
		nextArrow: customNext,
		customPaging: function (slider, i) {
			var thumb = $(slider.$slides[i]).data();
			return '<a>' + (i + 1) + '</a>';
		},
		responsive: [
			{
				breakpoint: 992,
				settings: {
					dots: true,
				},
			},
		],
	});

	$('.gallery-the-earplug').slick({
		slidesToShow: 2,
		slidesToScroll: 2,
		dots: false,
		arrows: true,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: true,
				},
			},
		],
	});

	const settingsPromotedProducts = {
		dots: false,
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 3,
		prevArrow: customPrev,
		nextArrow: customNext,
		responsive: [
			{
				breakpoint: 991,
				settings: 'unslick',
			},
		],
	};

	const promotedProducts = $('.front-page-top-slider').slick(
		settingsPromotedProducts,
	);

	const settings = {
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		mobileFirst: true,
		dots: true,
		// prevArrow: customPrev,
		// nextArrow: customNext,
		responsive: [
			{
				breakpoint: 767,
				settings: 'unslick',
			},
		],
	};

	const pressLogosSettings = {
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		dots: true,
		arrows: false,
		infinite: false,
		mobileFirst: true,

		responsive: [
			{
				breakpoint: 992,
				settings: 'unslick',
			},
		],
	}

	const sl = $('.new .gallery-wrapper').slick(settings);

	$(document).on('refresh_slider_images', function() {
		refreshImagesVariation()
	});
	


	function refreshImagesVariation() {

		if( $(window).outerWidth() <= 767 ) {

			sl.slick('slickFilter', function( index, element ) {
				return ! $(element).find('figure').hasClass('hide')
			});

			sl.slick('slickGoTo', 0)

		}

	}

	$('.image-slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		dots: true,
		arrows: false,
		infinite: false,
	})

	const brandingSlick = {
		slidesToShow: 1,
		autoplaySpeed: 5000,
		slidesToScroll: 1,
		autoplay: true,
		dots: true,
		arrows: false,
		infinite: true,
		mobileFirst: true,

		// responsive: [
		// 	{
		// 		breakpoint: 992,
		// 		settings: 'unslick',
		// 	},
		// ],

	}

	$('.branding-logos').slick(brandingSlick)
	
	// $(window).on('resize', function () {

	// 	if (! $('.branding-logos').hasClass('slick-initialized')) {
	// 		$('.branding-logos').slick(brandingSlick);
	// 	}

	// });

	$('.text-slider > div').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		dots: true,
		arrows: false,
		infinite: false,
		mobileFirst: true,
		adaptiveHeight: true,
		responsive: [
		    {
		        breakpoint: 768,
		        settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
		        }
		    },
		    {
		        breakpoint: 1500,
		        settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
		        }
		    }
		]
	})

	$('.press-list.multi > div').slick(pressLogosSettings)


	$('.grid-item.slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		dots: true,
		arrows: false,
		infinite: true,
	})

	$('.grid-item .slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		dots: true,
		arrows: false,
		infinite: true,
	})


	if( $('.additional-sales').length ) {

		$('.additional-sales').slick({
			slidesToShow: 1.5,
			slidesToScroll: 1,
			autoplay: false,
			dots: false,
			arrows: false,
			infinite: false,
			mobileFirst: true,
			// responsive: [
			//     {
			//         breakpoint: 992,
			//         settings: {
			// 			slidesToShow: 1.75,
			// 			slidesToScroll: 1,
			//         }
			//     }
			// ]
		})
	
	
	
		let blocked = false;
		let blockTimeout = null;
		let prevDeltaY = 0;
		
		$('.additional-sales').on('mousewheel DOMMouseScroll wheel', (function(e) {

			let deltaY = e.originalEvent.deltaY;

			e.preventDefault();

			e.stopPropagation();
		
			clearTimeout(blockTimeout);

			blockTimeout = setTimeout(function(){
				blocked = false;
			}, 50);
		
			if (deltaY > 0 && deltaY > prevDeltaY || deltaY < 0 && deltaY < prevDeltaY || !blocked) {

				blocked = true;

				prevDeltaY = deltaY;
		
				if (deltaY > 0) {
					$(this).slick('slickNext');
				} else {
					$(this).slick('slickPrev');
				}
			}

		}));



	
	}


	$(window).on('resize', function () {

		if (!sl.hasClass('slick-initialized')) {
			$('.new .gallery-wrapper').slick(settings);
			refreshImagesVariation()
		}

		if (!promotedProducts.hasClass('slick-initialized')) {
			$('.front-page-top-slider').slick(settingsPromotedProducts);
		}

		if (!$('.press-list.multi > div').hasClass('slick-initialized')) {
			$('.press-list.multi > div').slick(pressLogosSettings);
		}

		
	});


});


// jQuery(document).ready(function ($) {



// })

